import { html, type TemplateResult } from 'lit-html'

import type { App } from './app.ts'

/**
 * The Guild's common room (#138).
 *
 * Letters carry no free text, so the talking happens elsewhere: one link to
 * the Guild on Discord, drawn as the quiet underlined link the app uses for
 * the code of the Guild and never as a button. It opens in a new tab and
 * carries no referrer, because it leaves the Guild for somewhere the Guild
 * does not keep. The address is content rather than config, so a second
 * locale may keep a room of its own.
 *
 * On the landing's foot, on the desk and under the day's end; not on the
 * island, the letter or the post, which are the game.
 */
export function communityLink(app: App): TemplateResult {
  return html`<a
    class="quiet community"
    href=${app.t('communityUrl')}
    target="_blank"
    rel="noopener noreferrer"
    >${app.t('navCommunity')}</a
  >`
}
